export const SERVICE_SLUGS = [
  'overseas-fund-setup',
  'financial-licensing',
  'overseas-company',
  'mergers-acquisitions',
] as const;

export type ServiceSlug = (typeof SERVICE_SLUGS)[number];

export function isServiceSlug(slug: string): slug is ServiceSlug {
  return (SERVICE_SLUGS as readonly string[]).includes(slug);
}

export const serviceNavItems: { slug: ServiceSlug; labelKey: string; path: string }[] = [
  { slug: 'overseas-fund-setup', labelKey: 'nav.services.overseasFund', path: '/services/overseas-fund-setup' },
  { slug: 'financial-licensing', labelKey: 'nav.services.financialLicensing', path: '/services/financial-licensing' },
  { slug: 'overseas-company', labelKey: 'nav.services.overseasCompany', path: '/services/overseas-company' },
  { slug: 'mergers-acquisitions', labelKey: 'nav.services.mergersAcquisitions', path: '/services/mergers-acquisitions' },
];

export const serviceOverviewItems = [
  {
    slug: 'overseas-fund-setup' as const,
    icon: 'ri-funds-line',
    path: '/services/overseas-fund-setup',
    image: '/images/services-offshore-fund-setup.png',
    labelKey: 'servicesOverview.lines.overseasFund.label',
    descKey: 'servicesOverview.lines.overseasFund.desc',
    tags: [
      'servicesOverview.lines.overseasFund.tags.0',
      'servicesOverview.lines.overseasFund.tags.1',
      'servicesOverview.lines.overseasFund.tags.2',
    ],
  },
  {
    slug: 'financial-licensing' as const,
    icon: 'ri-bank-line',
    path: '/services/financial-licensing',
    image: '/images/services-financial-licensing.png',
    labelKey: 'servicesOverview.lines.financialLicensing.label',
    descKey: 'servicesOverview.lines.financialLicensing.desc',
    tags: [
      'servicesOverview.lines.financialLicensing.tags.0',
      'servicesOverview.lines.financialLicensing.tags.1',
      'servicesOverview.lines.financialLicensing.tags.2',
    ],
  },
  {
    slug: 'overseas-company' as const,
    icon: 'ri-building-4-line',
    path: '/services/overseas-company',
    image: '/images/services-overseas-company.png',
    labelKey: 'servicesOverview.lines.overseasCompany.label',
    descKey: 'servicesOverview.lines.overseasCompany.desc',
    tags: [
      'servicesOverview.lines.overseasCompany.tags.0',
      'servicesOverview.lines.overseasCompany.tags.1',
      'servicesOverview.lines.overseasCompany.tags.2',
    ],
  },
  {
    slug: 'mergers-acquisitions' as const,
    icon: 'ri-handshake-line',
    path: '/services/mergers-acquisitions',
    image: '/images/services-mergers-acquisitions.png',
    labelKey: 'servicesOverview.lines.mergersAcquisitions.label',
    descKey: 'servicesOverview.lines.mergersAcquisitions.desc',
    tags: [
      'servicesOverview.lines.mergersAcquisitions.tags.0',
      'servicesOverview.lines.mergersAcquisitions.tags.1',
      'servicesOverview.lines.mergersAcquisitions.tags.2',
    ],
  },
];

export function serviceTitleKey(slug: ServiceSlug): string {
  return `services.detail.${slug}.title`;
}

export function serviceSummaryKey(slug: ServiceSlug): string {
  return `services.detail.${slug}.summary`;
}

export function serviceContentKey(slug: ServiceSlug): string {
  return `services.detail.${slug}.content`;
}
